export const LIST_EXPORT_DATA_REQUEST = 'LIST_EXPORT_DATA_REQUEST'
export const LIST_EXPORT_DATA_SUCCESS = 'LIST_EXPORT_DATA_SUCCESS'
export const LIST_EXPORT_DATA_FAIL = 'LIST_EXPORT_DATA_FAIL'
export const LIST_EXPORT_DATA_RESET = 'LIST_EXPORT_DATA_RESET'

export const DOWNLOAD_EXPORT_DATA_REQUEST = 'DOWNLOAD_EXPORT_DATA_REQUEST'
export const DOWNLOAD_EXPORT_DATA_SUCCESS = 'DOWNLOAD_EXPORT_DATA_SUCCESS'
export const DOWNLOAD_EXPORT_DATA_FAIL = 'DOWNLOAD_EXPORT_DATA_FAIL'
